import React from 'react';
import styles from './ProductCard.module.css';

// Компонент получает props (свойства) от родителя (CatalogSection)
const ProductCard = ({ image, title, specs, price }) => {
  return (
    <div className={styles.card}>
      {/* Контейнер для изображения */}
      <div className={styles.imageContainer}>
        {/* 
          Используем placeholder-изображение, если основное не загрузилось.
          'image' - это путь, который мы передали из массива.
        */}
        <img src={image} alt={title} className={styles.image} />
      </div>

      {/* Контентная часть карточки */}
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        
        {/* Список характеристик */}
        <ul className={styles.specList}>
          {specs.map((spec, index) => (
            <li key={index} className={styles.specItem}>
              <span className={styles.specLabel}>{spec.label}:</span>
              <span className={styles.specValue}>{spec.value}</span>
            </li>
          ))}
        </ul>

        {/* Блок с ценой и кнопкой */}
        <div className={styles.footer}>
          <div className={styles.price}>{price}</div>
          <a href="#contact" className={styles.button}>
            Узнать подробнее
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;